import _http_v1 from "@packs/http_requests/_http_v1";
import _http_v2 from "@packs/http_requests/_http_v2";
import locale from "@packs/locale/locale";

const helper = {

    colors:{
        level:{
            attention: {full:'#bda501', light:'#fffdec'},
            alert: {full:'orange', light:'#fff9ed'},
            emergency: {full:'#cc00ff', light:'#f9e2ff'},
            extravasation: {full:'var(--danger)', light:'#ffe2e9'}
        },
        flow:{
            q95: {full: 'red', light: 'red'},
            normal: {full: 'green', light: 'green'}
        }  
    },
    reference_fields:{
        level:['extravasation', 'alert', 'emergency', 'attention'],
        flow:['q95', 'normal']
    },

    generateReferenceValues(reference_values,valueHandle, station_type='level'){
        
        let references = reference_values
        // let references = reference_values.filter(x=>x.values["extravasation"] || x.values["alert"] || x.values["attention"])

        const generateLabel = (field, value) =>{
            let label = locale.t(field)
            return label[0].toUpperCase() + label.substring(1,label.length) + " - " + value.toFixed(3) + `${station_type === 'level' ? ' m' : ' m³/s'}`
        }

        let plotlines = []
        references.forEach(reference=>{
            $.each(reference.values, (field, value)=>{
                if(value){
                    let hvalue = valueHandle ? valueHandle(parseFloat(value)) : parseFloat(value)
                    if(this.reference_fields[station_type].includes(field)){
                        
                        plotlines.push({
                            value: hvalue,
                            color: this.colors[station_type][field] ? this.colors[station_type][field].full : 'gray',
                            dashStyle: 'shortdash',
                            width: 2,
                            zIndex: 5,
                            label: {
                                text: generateLabel(field, hvalue)
                            }
                        })
                    }
                }
                
            })
        })
        
        return plotlines
        
    },
    setChartLimits(chart, custom_values = []){
        if(custom_values.length > 0){

        }
        chart.yAxis.forEach(axi=>{
            let plots = axi.plotLinesAndBands
            if(plots.length > 0){
                let plot_values = plots.map(x=>x.options.value)
                let {dataMax, dataMin} = axi.getExtremes()
                let all = [...plot_values, dataMax, dataMin];
                axi.setExtremes(Math.min(...all), Math.max(...all))
            } else {
                axi.setExtremes()
            }
            
            
        })
    },
    getFormatByGroupType(type){
        switch(type){
            case 'minute':
                return "YYYY-MM-DD HH:mm"
            case 'hour':
                return "YYYY-MM-DD HH"
            case 'day':
                return "YYYY-MM-DD"
            case 'month':
                return "YYYY-MM"
            default:
                return "DD-MM-DD HH:mm"
        }        
    },
    generateArimaSeries(arima, start, gap_in_minutes){
        
        
        let date = moment(start)
        let data = []

        arima.forEach((value,index)=>{
            date.add(gap_in_minutes, 'minutes')
            data.push({x:moment(date).valueOf(), type:'forecast', start: index === 0, y:parseFloat(value.toFixed(3))})
            // date.add(gap_in_minutes, 'minutes')
        })
        return data
    },
    generateSeries(measurements,yaxis_options,group_type){
        //por padrão, os dados das medições são em cm. Caso o yaxis_option tenha o value_type === 'm', será convertido em metros (value/100)

        let stations = {} //plu flu
        let series = []
        if(measurements && measurements.length > 0){
            measurements.forEach(measurement=>{

                stations[measurement.station_prefix_id] = stations[measurement.station_prefix_id] || {}
                stations[measurement.station_prefix_id].station_type_id = measurement.station_type_id
                stations[measurement.station_prefix_id].measurement_gap = measurement.measurement_gap
                stations[measurement.station_prefix_id]['value'] = stations[measurement.station_prefix_id]['value'] || []
                stations[measurement.station_prefix_id]['read_value'] = stations[measurement.station_prefix_id]['read_value'] || []
                stations[measurement.station_prefix_id]['read_value_flu'] = stations[measurement.station_prefix_id]['read_value_flu'] || []
                stations[measurement.station_prefix_id]['value'].push([moment(measurement.date, this.getFormatByGroupType(group_type)).subtract(3, 'hours').valueOf(), measurement.value, measurement.qtd_measurements]) //chuva/nivel
                if(measurement.read_value){
                    stations[measurement.station_prefix_id]['read_value'].push([moment(measurement.date, this.getFormatByGroupType(group_type)).subtract(3, 'hours').valueOf(), parseFloat(measurement.read_value.toFixed(3)), measurement.qtd_measurements]) //vazao
                }
                if(measurement.read_value_flu){
                    stations[measurement.station_prefix_id]['read_value_flu'].push([moment(measurement.date, this.getFormatByGroupType(group_type)).subtract(3, 'hours').valueOf(), parseFloat(measurement.read_value_flu.toFixed(3)), measurement.qtd_measurements]) //vazao
                }
                
            })
        }

        yaxis_options.forEach(yaxi=>{
            $.each(stations, (station_id, data)=>{
                if(data.station_type_id.toString() === '1'){                    
                    series.push(
                        {
                            name: measurements.filter(x=>x.station_prefix_id.toString() === station_id.toString())[0].station_name + ' - NÍVEL',
                            data: data[yaxi.station_type === 'level' ? 'value' : 'read_value'].map(x=>{return {qtd:x[2],x:['day','month'].includes(group_type) ? moment(x[0]).add(3, 'hours').valueOf() : x[0], y:yaxi.value_type === 'm' ? parseFloat((x[1]/100).toFixed(3)) : parseFloat(x[1].toFixed(3))}}),
                            station_prefix_id: station_id,
                            station_type: yaxi.station_type,
                            value_type: yaxi.value_type,
                            measurement_gap: data.measurement_gap
                        }
                    )
                } else if(yaxi.station_type === 'plu' && data.station_type_id.toString() === '2'){
                    series.push(
                        {
                            name: measurements.filter(x=>x.station_prefix_id.toString() === station_id.toString())[0].station_name + ' - CHUVA',
                            data: data['value'].map(x=>{return{qtd:x[2],x:['day','month'].includes(group_type) ? moment(x[0]).add(3, 'hours').valueOf() : x[0],y:parseFloat(x[1].toFixed(1))}}),
                            station_prefix_id: station_id,
                            type: 'column',
                            station_type: yaxi.station_type,
                            value_type: yaxi.value_type,
                            measurement_gap: data.measurement_gap
                        }
                    ) 
                } else if(data.station_type_id.toString() === '5'){
                    series.push(
                        {
                            name: measurements.filter(x=>x.station_prefix_id.toString() === station_id.toString())[0].station_name + ' - COT',
                            data: data['value'].map(x=>{return{qtd:x[2],x:['day','month'].includes(group_type) ? moment(x[0]).add(3, 'hours').valueOf() : x[0],y:parseFloat(x[1].toFixed(1))}}),
                            station_prefix_id: station_id,
                            type: 'line',
                            station_type: yaxi.station_type,
                            value_type: yaxi.value_type,
                            measurement_gap: data.measurement_gap
                        }
                    ) 
                }
            })
        })

        return series
    },
    async addForecastToSeries(series,forecastOptions){
        for(let i = 0;i<series.length; i++){
            let serie = series[i]

            if(serie.station_type === 'level' && forecastOptions && forecastOptions.flu && forecastOptions.flu.show){
                await $.ajax({
                    url: "https://cth.daee.sp.gov.br/forecast_models/arima",
                    type:"POST",
                    data: {data: JSON.stringify(serie.data.map(x=>(x.y * 100).toFixed(2)))}
                }).then(d=>{
                    let arima = this.generateArimaSeries(d.map(x=>x/100), serie.data[serie.data.length-1].x, serie.measurement_gap || 10) 
                    
                    serie.zoneAxis= 'x'

                    serie.zones = [
                        {
                            value: arima[0].x,
                        },
                        {
                            color:'var(--gray)'
                        }
                    ]

                    serie.data.push(...arima)
                })  
            }
                      
        }
        return series

    },
    async generateChart(measurements,options,arima_serie){
        //container, title, measurements, stations
        let {group_type,forecastOptions} = options
        
        //gerando séries
        let series = this.generateSeries(measurements, options.yaxis_options, group_type)
        series.map(x=>x.data = _.sortBy(x.data, ['x']))
        
        
        //gerando previsões para as séries
        if(forecastOptions){
            series = await this.addForecastToSeries(series,forecastOptions)
        }
        
        let valueHandler = value=>{
            return value / 100
        }

        let getFormatByGroupType = (type)=>{
            switch(type){
                case 'minute':
                    return "DD-MM-YYYY HH:mm"
                case 'hour':
                    return "DD-MM-YYYY HH:mm"
                case 'day':
                    return "DD-MM-YYYY"
                case 'month':
                    return "MM-YYYY"
                default:
                    return "DD-MM-YYYY HH:mm"
            }        
        }
        

        options.yaxis_options.forEach(yaxi=>{
            if(yaxi.reference_values && yaxi.reference_values.length > 0){
                
                yaxi.references = this.generateReferenceValues(yaxi.reference_values, yaxi.value_type === 'm' ? valueHandler : null, yaxi.station_type)

                
            }
        })

        let chart = Highcharts.chart({
            chart:{
                renderTo: options.container,
                type: 'line',
                zoomType: "x",
                show_flaws: true,
                events: {
                    load: event=> {
                      // The 'load' event is triggered when the chart is fully loaded
                      event.target.setChartExtremes = _ =>{
                        this.setChartLimits(event.target)
                      }
                      // You can perform additional actions here
                    }
                  }
            },
            
            title: {
                text: options.title,
                margin: 40,
                useHTML: true
            },
        
            xAxis: {
                type: 'datetime',
                crosshair: true,
            },
        
            yAxis:                 
                options.yaxis_options.map(x=> {
                    return {
                        title: {
                            text: x.name || 'undefined'
                        },
                        labels: {
                            format: x.label_format || '{value} mm'
                        },
                        plotLines: x.references || [],
                        opposite: x.opposite,
                    }
                }),
            tooltip: {
                shared: true,
                formatter: function (e) {
                    let html = '<b>' + moment(this.x).format(getFormatByGroupType(group_type)) + '</b><br>'
                    $.each(this.points, function(index, point){

                        let text = ""
                        let name = point.series.userOptions.name
                        let type = point.point.options.type
                        let value_type = point.series.userOptions.value_type

                        let qtd = point.point.options.qtd
                        
                        text += name+': <b><span style="color:'+ point.color +'">' + point.y +` ${value_type}</span></b>${qtd > 1 ? ' Qtd: <b>' + qtd + '</b>': ''}<br/>`

                        if(type === 'forecast'){
                            text += '<span style="color:red">(PREVISÃO)<span>'
                        }
                        html += text;
                    })
                    return html
                },
            },
            plotOptions: {
                series: {
                    // connectNulls: false,
                    events: {
                        legendItemClick: function(){
                            this.setVisible(this.visible)
                            return true
                        }
                    },
                    dataLabels: {
                        enabled: true,
                        useHTML:true,
                        formatter: function(){
                            const getStyle = value =>{
                                return `border:1px solid #c7c7c7;backgroundColor: white;border-radius:3px;padding:2px`
                            }
                            //exibir label apenas no valor max e min
                            let maxIndex = this.series.yData.indexOf(Math.max(...this.series.yData))
                            let minIndex = this.series.yData.indexOf(Math.min(...this.series.yData))
                            let maxTimestamp = this.series.xData[maxIndex]
                            let minTimestamp = this.series.xData[minIndex]

                            if(this.x === maxTimestamp){
                                
                                return `<div class='data-label-container data-label-max' style='${getStyle(this.y)}'>MAX: ${this.y}</div>`
                            } else if(this.x === minTimestamp){
                                return `<div class='data-label-container data-label-min' style='${getStyle(this.y)}'>MIN: ${this.y}</div>`
                            }

                            if(this.point.options.type === 'forecast' && this.point.options.start){
                                return `<div class='data-label-container data-label-min' style='border-radius:3px;padding:2px;color:white;background-color:var(--dark)'>PREVISÃO</div>`
                            }

                        }
                    }
                }
            },
        
            series: series,
        
            responsive: {
                rules: [{
                    condition: {
                        // maxWidth: 500
                    },
                    chartOptions: {
                        legend: {
                            // layout: 'horizontal',
                            // align: 'center',
                            // verticalAlign: 'bottom'
                        }
                    }
                }]
            },
            credits: {
                enabled: false
            }
        
        });

        this.setChartLimits(chart, options.yaxis_options[0].references || [], measurements, options.yaxis_options[0].references ? valueHandler:null)

        return chart
    },
    getMeasurements(station_ids, start_date, end_date,group_type){
        return _http_v2.request('measurements', 'GET', {station_prefix_ids:station_ids, start_date:start_date, end_date:end_date, group_type:group_type})
    }
}

export default helper;